module.exports = __webpack_public_path__ + "static/media/image (48).1dbe0c98.jpg";